/** Traduzioni inglesi dei blueprint (blocco 32). */
export const EN_BLUEPRINT: Record<string, string> = {
  // Elenco (blueprint.tsx)
  'Blueprint': 'Blueprints',
  // Il campo in cui se ne sceglie uno.
  'Blueprint|campo': 'Blueprint',
  'Nuovo blueprint': 'New blueprint',
  'Un blueprint è un pacchetto di moduli con un nome: quelli standard di Odoo, quelli dei vostri repository e di OCA, le librerie Python che servono. Si applica a un’istanza accesa, dalla sua scheda, o a una nuova, alla creazione: un solo lavoro, con una copia del database prima.':
    'A blueprint is a named package of modules: Odoo’s standard ones, those from your repositories and from OCA, and the Python libraries they need. It is applied to a running instance, from its page, or to a new one, at creation: a single job, with a database copy first.',
  'Non riesco a leggere i blueprint': 'Can’t read the blueprints',
  'Nessun blueprint ancora. Il primo di solito è quello che installate su ogni cliente.':
    'No blueprints yet. The first one is usually what you install for every customer.',
  'Crea il primo blueprint': 'Create the first blueprint',
  '1 modulo': '1 module',
  '{n} moduli': '{n} modules',
  '1 repository': '1 repository',
  '{n} repository': '{n} repositories',
  '1 libreria': '1 library',
  '{n} librerie': '{n} libraries',
  // Modifica
  'Questo blueprint non c’è più': 'This blueprint no longer exists',
  'Torna ai blueprint': 'Back to blueprints',
  'Blueprint salvato': 'Blueprint saved',
  'Blueprint eliminato': 'Blueprint deleted',
  'Come lo cercherà chi crea un’istanza, es. «Base cliente» o «E-commerce».':
    'How whoever creates an instance will look for it, e.g. «Customer base» or «E-commerce».',
  'Descrizione': 'Description',
  'Moduli standard di Odoo': 'Standard Odoo modules',
  'Nomi tecnici, separati da spazi o virgole: quelli che Odoo ha già, e con Enterprise anche i suoi.':
    'Technical names, separated by spaces or commas: those Odoo already has, and with Enterprise its own too.',
  'Librerie Python, una per riga': 'Python libraries, one per line',
  'Si aggiungono a quelle dell’istanza, non le sostituiscono.': 'They are added to the instance’s own, they don’t replace them.',
  'Repository': 'Repositories',
  'Nessuno: il blueprint installa solo moduli standard. Un repository di OCA o vostro porta i suoi moduli, sul ramo della versione dell’istanza.':
    'None: the blueprint only installs standard modules. An OCA repository or one of yours brings its modules, on the branch of the instance’s version.',
  'Nuovo repository': 'New repository',
  'Togli il repository': 'Remove the repository',
  'la versione dell’istanza, es. 18.0': 'the instance’s version, e.g. 18.0',
  'Vuoto: il ramo della versione di Odoo dell’istanza, così lo stesso blueprint va su una 17 e su una 18.':
    'Empty: the branch of the instance’s Odoo version, so the same blueprint fits a 17 and an 18.',
  'Moduli da installare': 'Modules to install',
  'Almeno uno. Uno che nel ramo non c’è si dice quando lo applichi, e gli altri si installano lo stesso.':
    'At least one. One that isn’t in the branch is reported when you apply it, and the others are installed anyway.',
  'Non l’ho eliminato': 'I didn’t delete it',
  'Elimina': 'Delete',
  'Eliminare {nome}?': 'Delete {nome}?',
  'Le istanze su cui l’hai applicato restano come sono: il blueprint era la ricetta, non un legame.':
    'The instances you applied it to stay as they are: the blueprint was the recipe, not a link.',
  'Chiave di deploy per {repo}': 'Deploy key for {repo}',
  'Il repository è privato: arriva sul server con la chiave dell’azienda. Se non l’hai già fatto, su GitHub: «Settings → Deploy keys → Add deploy key», {senza} spuntare «Allow write access».':
    'The repository is private: it reaches the server with the company key. If you haven’t already, on GitHub: «Settings → Deploy keys → Add deploy key», {senza} ticking «Allow write access».',
  // Dal catalogo (blueprint-catalogo.tsx)
  'Aggiungi dal catalogo': 'Add from the catalog',
  'Aggiungi per indirizzo': 'Add by address',
  'I repository di OCA e delle vostre organizzazioni GitHub: dopo scegli il ramo e i moduli.':
    'The repositories of OCA and of your GitHub organizations: then choose the branch and the modules.',
  'Scrivi per restringere: ne mostro {n} su {tot}.': 'Type to narrow it down: showing {n} of {tot}.',
  'La versione dell’istanza': 'The instance’s version',
  'Fisso: ogni istanza prende questo ramo, di qualunque versione sia.':
    'Fixed: every instance takes this branch, whatever its version.',
  'Ogni istanza prende il ramo della sua versione di Odoo: lo stesso blueprint va su una 17 e su una 18.':
    'Each instance takes the branch of its Odoo version: the same blueprint fits a 17 and an 18.',
  'Scegli almeno un modulo.': 'Choose at least one module.',
  'solo nel {rami}': 'only in {rami}',
  'Il repository non ha rami col nome di una versione di Odoo: scegline uno.':
    'The repository has no branches named after an Odoo version: choose one.',
  // Applicazione (scheda dell'istanza)
  'Applico {nome}: l’istanza si ferma un momento': 'Applying {nome}: the instance stops for a moment',
  'Blueprint…': 'Blueprint…',
  'Applica un blueprint': 'Apply a blueprint',
  'Collego i repository che mancano, aggiungo le librerie e installo i moduli, in un solo lavoro con una copia del database prima. I moduli già installati li salto.':
    'I link the missing repositories, add the libraries and install the modules, in a single job with a database copy first. Modules already installed are skipped.',
  'Ho incollato, applica': 'I pasted it, apply',
  'Applica': 'Apply',
  'Nessun blueprint ancora: li crei in {pagina}.': 'No blueprints yet: you create them in {pagina}.',
  'Installo': 'Installing',
  'Già installati': 'Already installed',
  'Non nel ramo': 'Not in the branch',
  'Saltati': 'Skipped',
  'Repository lasciati fuori': 'Repositories left out',
  'Partito': 'Started',
  'Niente da fare: è già tutto installato': 'Nothing to do: everything is already installed',
  // Nuova istanza (instances.tsx)
  'Nessuno': 'None',
  'Appena l’istanza è accesa installo il blueprint, con un lavoro suo: se non va, l’istanza resta e lo riapplichi dalla sua scheda.':
    'As soon as the instance is running I install the blueprint, in a job of its own: if it fails, the instance stays and you reapply it from its page.',
  'Un pacchetto di moduli da installare appena l’istanza è pronta.': 'A package of modules to install as soon as the instance is ready.',
};
